export default "__VITE_ASSET__DpBA4weg__"